module.exports = __webpack_public_path__ + "dc3bf530413cb55b6c116f321eccf1cd.svg";